import type { CsvFlowAdapter } from '../../shared/csv/hooks/csvFlowAdapter';
import { loadWebCustomerSnapshot } from './webCustomerSnapshotCache';
import {
  buildCustomerCsvExport,
  buildCustomerCsvTemplate,
  buildCustomerImportErrorsCsv,
  commitCustomerCsvImport,
  previewCustomerCsvImport,
} from './customerCsvImport';
import { customerCsvExportFilename, customerCsvTemplateFilename } from './customerCsvSchemas';
import { countCustomerAccounts, fetchCustomerAccounts } from './customerAccounts';

export function createCustomerCsvAdapter(): CsvFlowAdapter {
  return {
    buildTemplate: () => buildCustomerCsvTemplate(),
    templateFilename: () => customerCsvTemplateFilename(),
    buildExport: async () => {
      const total = await countCustomerAccounts();
      const rows = total > 0 ? await fetchCustomerAccounts({ limit: total, offset: 0 }) : [];
      return buildCustomerCsvExport(rows);
    },
    exportFilename: () => customerCsvExportFilename(),
    previewImport: previewCustomerCsvImport,
    commitImport: commitCustomerCsvImport,
    buildImportErrorsCsv: buildCustomerImportErrorsCsv,
    syncSnapshot: async () => {
      await loadWebCustomerSnapshot(true);
    },
  };
}
